export function debounce(fn, time) {
  let timeoutId;
  return wrapper;
  function wrapper(...props) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...props);
    }, time);
  }
}
